export default "__VITE_ASSET__248d77c8__"